export var NetworkNames;
(function (NetworkNames) {
    NetworkNames["MAINNET"] = "MAINNET";
    NetworkNames["MORDEN"] = "MORDEN";
    NetworkNames["ROPSTEN"] = "ROPSTEN";
    NetworkNames["RINKEBY"] = "RINKEBY";
    NetworkNames["GOERLI"] = "GOERLI";
    NetworkNames["KOVAN"] = "KOVAN";
    NetworkNames["XDAI"] = "XDAI";
    NetworkNames["ENERGY_WEB_CHAIN"] = "ENERGY_WEB_CHAIN";
    NetworkNames["VOLTA"] = "VOLTA";
})(NetworkNames || (NetworkNames = {}));
export const getNetworkIdFromName = (networkName) => {
    if (!networkName)
        return;
    const networks = {
        MAINNET: 1,
        MORDEN: 2,
        ROPSTEN: 3,
        RINKEBY: 4,
        GOERLI: 5,
        KOVAN: 42,
        XDAI: 100,
        ENERGY_WEB_CHAIN: 246,
        VOLTA: 73799
    };
    return networks[networkName.toUpperCase()];
};
//# sourceMappingURL=networks.js.map